import { plural } from './plural';
import { shortDate } from './usDate';

const DAY_MS = 86400000;

const nameOf = (row) => `${row.first_name ?? ''} ${row.last_name ?? ''}`.trim() || row.email;

const chaseText = (chases) => {
  if (!chases) return '';
  if (chases === 1) return 'chased once';
  if (chases === 2) return 'chased twice';

  return `chased ${chases} times`;
};

const waitingTag = (row, now) => {
  const days = Math.max(0, Math.floor((now.getTime() - new Date(row.happened_at).getTime()) / DAY_MS));

  if (days === 0) return 'Waiting since today';

  return `Waiting ${days} ${days === 1 ? 'day' : 'days'}`;
};

const KINDS = {
  invited: {
    story: (row, when, by, chase) => ['invited ' + when + by, chase],
    tag: (row, now) => ({ tag: waitingTag(row, now), tagTone: 'warning' }),
    primary: 'Send again',
    primaryVariant: 'ghost',
    secondaryLabel: 'Cancel invitation',
    secondaryAria: (name) => `Cancel the invitation to ${name}`,
  },
  approved: {
    story: (row, when, by) => ['asked for access', `approved ${when}${by}`],
    tag: (row, now) => ({ tag: waitingTag(row, now), tagTone: 'warning' }),
    primary: 'Send again',
    primaryVariant: 'ghost',
    secondaryLabel: 'Remove access',
    secondaryAria: (name) => `Remove access for ${name}`,
  },
  granted: {
    story: (row, when, by) => [`access granted ${when}${by}`],
    tag: () => ({ tag: 'Not invited yet', tagTone: '' }),
    primary: 'Send an invitation',
    primaryVariant: 'filled',
    secondaryLabel: 'Remove access',
    secondaryAria: (name) => `Remove access for ${name}`,
  },
};

export const describeRow = (row, now = new Date()) => {
  const kind = KINDS[row.kind] ?? KINDS.granted;
  const by = row.actor_name ? ` by ${row.actor_name}` : '';
  const story = kind.story(row, shortDate(row.happened_at), by, chaseText(row.chases)).filter(Boolean);

  return {
    line: [row.email, ...story].join(' · '),
    ...kind.tag(row, now),
    primary: kind.primary,
    primaryVariant: kind.primaryVariant,
    secondaryLabel: kind.secondaryLabel,
    secondaryAria: kind.secondaryAria(nameOf(row)),
  };
};

const firstNameOf = (row) => (row.first_name ?? '').trim() || row.email;

export const sentToast = (row) => {
  const who = firstNameOf(row);

  if (row.kind === 'approved') return `Sign-up link sent again to ${who}`;

  return row.kind === 'invited' ? `Invitation sent again to ${who}` : `Invitation sent to ${who}`;
};

export const removedToast = (row) => (row.kind === 'invited' ? 'Invitation cancelled' : 'Access removed');

export const importedLine = (row) => {
  const parts = [
    row.phone,
    row.policy_count ? plural(row.policy_count, 'policy', 'policies') : '',
    row.next_renewal?.renewal_date ? `renews ${shortDate(row.next_renewal.renewal_date)}` : '',
  ].filter(Boolean);

  return parts.length ? parts.join(' · ') : 'No phone or policies imported';
};
